import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

const FileUpload = ({
  name,
  maxSize,
  accept = '*',
  disabled,
  previewSrc = '//static.beeline.ru/upload/images/b2c/selfReg/file-{{type}}.svg',
  previewElement,
  onChange,
  children,
  className,
}) => {
  const [defaultSrc, setDefaultSrc] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    onChange(null);
  }, []);

  useEffect(() => {
    if (previewElement) {
      setDefaultSrc(previewElement.src);
    }
  }, [previewElement]);

  const onUploadClick = () => {
    inputRef.current.click();
  };

  const onLoad = (e) => {
    const input = e.target;
    const file = input.files && input.files[0];

    if (!file || file.size > maxSize) {
      previewElement.setAttribute('src', defaultSrc);
      onChange(null, 'tooLarge');
      return;
    }

    onChange(file || null);

    if (file.type.includes('image')) {
      const reader = new FileReader();
      reader.onload = (readerEvent) => {
        previewElement.setAttribute('src', readerEvent.target.result);
      };
      reader.readAsDataURL(file);
    } else if (file.type.includes('application')) {
      const fileType = file.type.replace('application/', '');
      previewElement.setAttribute(
        'src',
        previewSrc.replace('{{type}}', fileType),
      );
    }
  };

  return (
    <>
      <input
        className={cx('input', className)}
        name={name}
        type="file"
        ref={inputRef}
        accept={accept}
        onChange={onLoad}
        disabled={disabled}
      />
      {React.cloneElement(children, {
        onClick: onUploadClick,
        disabled,
      })}
    </>
  );
};

FileUpload.propTypes = {
  name: PropTypes.string,
  maxSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  accept: PropTypes.string,
  disabled: PropTypes.bool,
  previewSrc: PropTypes.string,
  previewElement: PropTypes.node,
  onChange: PropTypes.func,
  className: PropTypes.any,
};

export default FileUpload;
